import React from 'react'
import './NewCollections.css'
import Item from '../Items/Item'
import new_collections from '../Assets/newCollections'

const NewCollections = () => {
  return (
    <div className='new-collections'>
        <h1>ANIMALS IN STOCK</h1>
        <hr />
<div className="livestock">
    {new_collections.map((item,i)=>{ 

        return <Item key={i} id={item.id}  name={item.name} image={item.image}  oldPrice={item.oldPrice} newPrice={item.newPrice}/>
        
    })}
    </div>     



    </div>
  )
}

export default NewCollections